import { render, staticRenderFns } from "./Resumen_partida.vue?vue&type=template&id=0e101a4e&lang=pug&"
import script from "./Resumen_partida.vue?vue&type=script&lang=js&"
export * from "./Resumen_partida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports